import facebook from "./social-icons/facebook.svg";
import x from "./social-icons/x.svg";
import instagram from "./social-icons/instagram.svg";
import youtube from "./social-icons/youtube.svg";
import spotify from "./social-icons/spotify.svg";
import apple from "./social-icons/apple.svg";
import tiktok from "./social-icons/tiktok.svg";
import "./style.css";

export const SocialLinks = ({ className }) => {
  return (
    <ul className={`social-networking ${className}`}>
      <li className="social-networking__item">
        <a href="/" target="_blank" rel="noreferrer">
          <div>
            <img alt="Facebook" src={facebook} />
          </div>
        </a>
      </li>

      <li className="social-networking__item">
        <a href="/" target="_blank" rel="noreferrer">
          <div>
            <img alt="X" src={x} />
          </div>
        </a>
      </li>
      <li className="social-networking__item">
        <a href="/" target="_blank" rel="noreferrer">
          <div>
            <img className="instagram-logo" alt="Instagram" src={instagram} />
          </div>
        </a>
      </li>
      <li className="social-networking__item">
        <a href="/" target="_blank" rel="noreferrer">
          <div>
            <img className="youtube-logo" alt="Youtube" src={youtube} />
          </div>
        </a>
      </li>
      <li className="social-networking__item" rel="noreferrer">
        <a href="/" target="_blank">
          <div>
            <img className="spotify-logo" alt="Spotify" src={spotify} />
          </div>
        </a>
      </li>
      <li className="social-networking__item">
        <a href="/" target="_blank" rel="noreferrer">
          <div>
            <img className="apple-logo" alt="Apple" src={apple} />
          </div>
        </a>
      </li>
      <li className="social-networking__item">
        <a href="/" target="_blank" rel="noreferrer">
          <div>
            <img className="tiktok-logo" alt="Tiktok" src={tiktok} />
          </div>
        </a>
      </li>
    </ul>
  );
};
